<template>
  <div class="rate-display">
    <div class="row">
      <div class="col-sm-12">
        <div class="toolbar pull-right">
          <router-link class="btn btn-warning" :to="{ path: '/membership/rates/vehicles/edit/' + rate.uuid }"><span class="fa fa-edit fa-fw"></span> Edit Rate</router-link>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h1 class="box-title">Rate Details</h1>
            <div class="box-tools pull-right">
            </div>
          </div>
          <div class="box-body">
            <table class="table table-condensed">
              <tr>
                <td><strong>Car Type</strong></td>
                <td>{{ rate.CarType.name }}</td>
              </tr>
              <tr>
                <td><strong>Hourly Rate</strong></td>
                <td>{{ rate.hourlyRate | to_dollar_amount }}</td>
              </tr>
              <tr>
                <td><strong>Daily Rate</strong></td>
                <td>{{ rate.dailyRate | to_dollar_amount }}</td>
              </tr>
              <tr>
                <td><strong>Weekend Rate</strong></td>
                <td>{{ rate.weekendRate | to_dollar_amount }}</td>
              </tr>
              <tr>
                <td><strong>Included KMs</strong></td>
                <td>{{ rate.includedKms }}</td>
              </tr>
              <tr>
                <td><strong>Per KM Cost</strong></td>
                <td>{{ rate.perKmCost | to_dollar_amount }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RateDisplay',
  data () {
    return {
      rate: {
        CarType: {
          name: ''
        }
      }
    }
  },
  route: {
    data () {
      let params = this.$route.params
      let { meta } = this.$route.matched.find(m => m.meta.authType)
      this.$http.get(`${meta.authType}/object/rate`, { params }).then(({ data }, status, request) => {
        this.rate = data.object
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/RateDisplay.vue